/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Red_Antsy_Canary_BelieveInputs */

const fr_red_antsy_canary_believe = /** @type {(inputs: Red_Antsy_Canary_BelieveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

/**

* @param {Red_Antsy_Canary_BelieveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const red_antsy_canary_believe = /** @type {((inputs?: Red_Antsy_Canary_BelieveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Red_Antsy_Canary_BelieveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_red_antsy_canary_believe(inputs)
});